import { render, staticRenderFns } from "./MaterialDashboardQueuesList.vue?vue&type=template&id=5408a9f5&"
import script from "./MaterialDashboardQueuesList.vue?vue&type=script&lang=js&"
export * from "./MaterialDashboardQueuesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports